export enum EPostHogEvents {
	TICKET_PAGE_VIEWED = 'ticket_page_viewed',
	TICKET_PAGE_END = 'ticket_page_end',
	TICKET_NOTE_CREATED = 'ticket_note_created',
	TICKET_NOTE_EDITED = 'ticket_note_edited',
	TICKET_STAGE_CHANGED = 'ticket_stage_changed',

	CRM_PAGE_VIEWED = 'crm_page_viewed',
	CRM_PAGE_END = 'crm_page_end',
	CRM_SMART_VARIABLE_CREATED = 'crm_smart_variable_created',

	CALENDAR_PAGE_VIEWED = 'calendar_page_viewed',
	CALENDAR_PAGE_END = 'calendar_page_end',
	CALENDAR_WORKFLOW_MODAL_OPENED = 'calendar_workflow_modal_opened',
	CALENDAR_WORKFLOW_MODAL_CLOSED = 'calendar_workflow_modal_closed',
	CALENDAR_WORKFLOW_CREATED = 'calendar_workflow_created',

	TEXTING_AGENT_PAGE_VIEWED = 'texting_agent_page_viewed',
	TEXTING_AGENT_PAGE_END = 'texting_agent_page_end',
}
